import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CollaboratorDto } from '../../models/collaborator.dto';
import { PageResponse, SearchRequest } from '../utils/common.utils';

@Injectable({
  providedIn: 'root'
})
export class CollaboratorsService {
  private endpoint: string = environment.apiServer + '/api/collaborators';

  constructor(
    private httpClient: HttpClient,
  ) {
  }

  getLoggedCollaborator(): Observable<CollaboratorDto.View> {
    return this.httpClient.get<CollaboratorDto.View>(`${this.endpoint}/me`);
  }

  getCollaboratorById(collaboratorId: string): Observable<CollaboratorDto.View> {
    return this.httpClient.get<CollaboratorDto.View>(`${this.endpoint}/${collaboratorId}`);
  }

  createCollaborator(collab: CollaboratorDto.Create): Observable<CollaboratorDto.View> {
    return this.httpClient.post<CollaboratorDto.View>(`${this.endpoint}`, collab);
  }

  updateCollaborator(collaboratorId: string, collab: CollaboratorDto.Update): Observable<CollaboratorDto.View> {
    return this.httpClient.put<CollaboratorDto.View>(`${this.endpoint}/${collaboratorId}`, collab);
  }

  modifyCollaboratorAuthAccess(collabId: string): Observable<void> {
    return this.httpClient.put<void>(`${this.endpoint}/${collabId}/auth-access`, null);
  }

  updateCollaboratorsFromAdminPulse(): Observable<void> {
    return this.httpClient.put<void>(`${this.endpoint}/admin-pulse`, null);
  }

  // Lightweight active-collaborator lookup for the @mention picker (q = global contains search).
  searchCollaborators(query: string, size = 8): Observable<PageResponse<CollaboratorDto.View>> {
    const req: SearchRequest = {
      page: 0,
      size,
      sort: ['lastname,asc'],
      filters: query ? [{ field: 'q', op: 'CONTAINS', value: query }] : []
    };
    return this.httpClient.post<PageResponse<CollaboratorDto.View>>(
      `${this.endpoint}/search?activeElementsSearch=true`, req);
  }
}
